export default function(item) {
    return item.trim();
}